export default {"src":"/_next/static/media/overcoming-obstacles.mono.3611d861.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};